// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__YigiO","location":"Header_location__2ngOL"};